/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_TitleInputs */

const en_site_title = /** @type {(inputs: Site_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the cheapest, most reliable data.`)
};

const zh_hans1_site_title = /** @type {(inputs: Site_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取最便宜、最可靠的数据。`)
};

const pt_br2_site_title = /** @type {(inputs: Site_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenha os dados mais baratos e confiáveis.`)
};

const es_site_title = /** @type {(inputs: Site_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén los datos más baratos y confiables.`)
};

const fr_site_title = /** @type {(inputs: Site_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les données les moins chères et les plus fiables.`)
};

const de_site_title = /** @type {(inputs: Site_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die günstigsten, zuverlässigsten Daten.`)
};

const ru_site_title = /** @type {(inputs: Site_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самые выгодные и надёжные данные.`)
};

const it_site_title = /** @type {(inputs: Site_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni i dati più economici e affidabili.`)
};

/**
* | output |
* | --- |
* | "Get the cheapest, most reliable data." |
*
* @param {Site_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const site_title = /** @type {((inputs?: Site_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_site_title(inputs)
	if (locale === "pt-BR") return pt_br2_site_title(inputs)
	if (locale === "es") return es_site_title(inputs)
	if (locale === "fr") return fr_site_title(inputs)
	if (locale === "de") return de_site_title(inputs)
	if (locale === "ru") return ru_site_title(inputs)
	if (locale === "it") return it_site_title(inputs)
	return en_site_title(inputs)
});